import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LiteModeContext = createContext({ lite: false, ready: false });

/** Mode allégé (LITE_MODE backend) : instance mono-entreprise sans couche multi-tenant. */
export function LiteModeProvider({ children }) {
  const [state, setState] = useState({ lite: false, ready: false });
  useEffect(() => {
    axios.get(`${API}/platform/mode`)
      .then((r) => setState({ lite: !!r.data?.lite, ready: true }))
      .catch(() => setState({ lite: false, ready: true }));
  }, []);
  return <LiteModeContext.Provider value={state}>{children}</LiteModeContext.Provider>;
}

export const useLiteMode = () => useContext(LiteModeContext);

/** Bloque une route quand le mode allégé est actif (redirige). */
export function LiteBlocked({ children, to = "/login" }) {
  const { lite, ready } = useLiteMode();
  if (!ready) return null;
  if (lite) return <Navigate to={to} replace />;
  return children;
}
